import { QueryFunction, skipToken, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { Translations } from '@lifeserver/shared';

const TRANSLATIONS_PATH = '/api/translations/v2';

const getTranslations: QueryFunction<
    Translations,
    [string, string, string]
> = async ({ queryKey: [url, range, stringId], signal }) => {
    const { data } = await axios.get(
        `${url}?range=${range}&stringId=${stringId}`,
        {
            signal,
        },
    );
    return data;
};

export const useTranslations = (range: string, stringId?: string) => {
    return useQuery({
        queryKey: [TRANSLATIONS_PATH, range, stringId ?? ''],
        queryFn:
            stringId !== undefined && stringId !== null
                ? getTranslations
                : skipToken,
    });
};
